import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { StyledAdminGroupPoolConfigsListHeader } from './styles';
import { AdminListHeaderCell } from '../AdminListHeaderCell';
import { TSortAdminGroupPoolConfigsByHeaderTitle } from 'types';

interface IGroupPoolConfigsListHeaderProps {
  children?: React.ReactNode;
}

type FieldType = {
  key: TSortAdminGroupPoolConfigsByHeaderTitle;
};

export const headerFields: FieldType[] = [
  { key: 'priority' },
  { key: 'name' },
  { key: 'host' },
  { key: 'port' },
  { key: 'algorithm' },
  { key: 'maxAttempts' },
  { key: 'user' },
  { key: 'password' },
];

export const AdminGroupPoolConfigsListHeader = ({ children }: IGroupPoolConfigsListHeaderProps) => {
  const { t } = useTranslation();

  return (
    <StyledAdminGroupPoolConfigsListHeader>
      <div className={cn('admin-list-header-cell-container', 'order')}>
        <AdminListHeaderCell fieldKey="order">
          {t('adminPage.editGroupPoolConfigs.listHeaders.order')}
        </AdminListHeaderCell>
      </div>

      {headerFields.map(({ key }) => (
        <div key={key} className={cn('admin-list-header-cell-container', key.toLowerCase())}>
          <AdminListHeaderCell fieldKey={key}>
            {t(`adminPage.editGroupPoolConfigs.listHeaders.${key}`)}
          </AdminListHeaderCell>
        </div>
      ))}

      <div className={cn('admin-list-header-cell-container', 'actions')}>
        <AdminListHeaderCell fieldKey="actions">
          {t('adminPage.editPoolConfigs.listHeaders.actions')}
        </AdminListHeaderCell>
      </div>
    </StyledAdminGroupPoolConfigsListHeader>
  );
};
